import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFactSheetHeaderComponent } from './kn-br-fact-sheet-header.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { SpinnerModule, PageSlotModule } from '@spartacus/storefront';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        NgbModule,
        PageSlotModule,
        SpinnerModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrFactSheetHeaderComponent: {
                    component: KnBrFactSheetHeaderComponent,
                },
            },
        } as CmsConfig),
        KnBrFactSheetHeaderComponent,
    ],
})
export class KnBrFactSheetHeaderModule {}
